export const RESET_ADMIN_USER_PASSWORD = "RESET_ADMIN_USER_PASSWORD"
export const RESET_ADMIN_USER_PASSWORD_SUCCESS =
  "RESET_ADMIN_USER_PASSWORD_SUCCESS"
export const RESET_ADMIN_USER_PASSWORD_ERROR = "RESET_ADMIN_USER_PASSWORD_ERROR"

export const FORGOT_ADMIN_USER_PASSWORD = "FORGOT_ADMIN_USER_PASSWORD"
export const FORGOT_ADMIN_USER_PASSWORD_SUCCESS =
  "FORGOT_ADMIN_USER_PASSWORD_SUCCESS"
export const FORGOT_ADMIN_USER_PASSWORD_ERROR =
  "FORGOT_ADMIN_USER_PASSWORD_ERROR"

export const NEW_ADMIN_USER_PASSWORD = "NEW_ADMIN_USER_PASSWORD"
export const NEW_ADMIN_USER_PASSWORD_SUCCESS = "NEW_ADMIN_USER_PASSWORD_SUCCESS"
export const NEW_ADMIN_USER_PASSWORD_ERROR = "NEW_ADMIN_USER_PASSWORD_ERROR"

export const UPDATE_ADMIN_USER_PASSWORD = "UPDATE_ADMIN_USER_PASSWORD"
export const UPDATE_ADMIN_USER_PASSWORD_SUCCESS = "UPDATE_ADMIN_USER_PASSWORD_SUCCESS"
export const UPDATE_ADMIN_USER_PASSWORD_ERROR = "UPDATE_ADMIN_USER_PASSWORD_ERROR"
